import { Box, CardContent, Grid, Skeleton, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
// import moment from 'moment';

const WorkerDetailSkeleton = () => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        // marginTop: 4,
        borderRadius: 2.5,
        padding: { xs: 1, sm: 2 },
        border: "1px solid #f5f5f5",
        backgroundColor: "text.white",
        boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Worker Details */}
      <Grid item xs={12} md={4}>
        <Typography variant="h6" fontWeight={600} gutterBottom textTransform={'capitalize'}>
          {t("workerDetails")}
        </Typography>
        <Box
          width={"100%"}
          height={230}
          borderRadius={"12px"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            background: "linear-gradient(135deg, #9700e1, #ceaffff5)",
          }}
        >
          <Skeleton variant="circular" width={160} height={160} />
        </Box>
        <Stack gap={1} mt={2}>
          <Skeleton variant="rectangular" height={36} width={120} />
          <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
            <Skeleton variant="text" width={120} />
            <Skeleton variant="text" width={80} />
          </Box>
          <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
            <Skeleton variant="text" width={120} />
            <Skeleton variant="text" width={80} />
          </Box>
          <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
            <Skeleton variant="text" width={120} />
            <Skeleton variant="text" width={80} />
          </Box>
        </Stack>
      </Grid>

      {/* Main Content */}
      <Grid item xs={12} md={8}>
        <CardContent sx={{ mt: 2.5 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={200} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={200} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={200} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={200} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={200} />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={300} />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={250} />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Grid>
    </Grid>
  );
};

export default WorkerDetailSkeleton;
